<template>
  <div class="wrapper-comment">
    <div class="block-like" v-if="likeCount > 0 || userData.like">
      <img class="media" mode="widthFix" src="@/static/images/like.png" />
      <span class="popular">{{getLikeTip(likeCount, userData)}}</span>
    </div>
    <div class="item-list" v-if="replys.length>0">
      <div class="list-item" v-for="reply in replys" :key="reply.id">
        <replyItem :reply="reply"></replyItem>
      </div>
    </div>
    <div class="addition" v-if="totalNum>3&&replys.length>0" @click="linkToFundBarDetail(userData)">
      全部{{totalNum}}条{{source===1?'回复':'评论'}}
      <img class="img-more" src="@/static/images/more.png" />
    </div>
  </div>
</template>

<script>
import replyItem from '@/components/Fund-reply-item.vue';
import Util from '@/base/Util';
import {
  detailPushPage,
} from '@/utils/nativeBridge';

export default {
  name: 'reply',
  props: {
    replys: Array,
    totalNum: {
      required: true,
      type: Number,
    },
    likeCount: {
      type: Number,
      default: 0,
    },
    source: {
      require: true,
      type: Number,
    },
    userData: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    replyItem,
  },
  data() {
    return {
      album: [],
    };
  },
  methods: {
    getLikeTip(likeCount, userData) {
      if (likeCount > 0) {
        if (userData.like) {
          return `你和其他${likeCount}人`;
        }
        return `${likeCount}人`;
      }
      if (userData.like) {
        return '你赞了';
      }
      return '';
    },
    isString(val) {
      return Object.prototype.toString.call(val).slice(8, -1) === 'String';
    },
    linkToFundBarDetail(item) {
      const { PostId, Type, TypeAbout } = item;
      // 默认帖子
      let url = `fund://page/fbarticle?postid=${PostId}&scrollcomment=false`;
      if (Type === 49) {
        // 提问
        url = `fund://page/barQuestionDetail?postid=${PostId}&qid=${TypeAbout.QuestionId}`;
      } else if (Type === 50) {
        // 回答
        url = `fund://page/barAnswerDetail?postid=${PostId}&qid=${TypeAbout.QuestionId}&aid=${TypeAbout.AnswerId}`;
      }
      detailPushPage({
        type: 1,
        url,
      });
      this.reportMonitor({
        eventName: 'pz.jjtl.neirong',
        infoCodeType: '5',
        infoCode: this.fundCode,
        postid: PostId,
        eventContent: {
          postid: PostId,
        },
      });
    },
    handlePlaceholder(val) {
      let textBooms = val.textend.split(/(\[\W+?\]|<!--\w+-->)/).filter((item) => item.trim() !== '');
      for (let i = 0, len = textBooms.length; i < len; i += 1) {
        for (let j = 0, jlen = val.replykeywords.length; j < jlen; j += 1) {
          if (val.replykeywords[j].Label === textBooms[i]) {
            textBooms[i] = val.replykeywords[j];
            if ([100].includes(val.replykeywords[j].Type)) {
              const [, src] = val.replykeywords[j].PicImg.match(/"(.*)"/);
              textBooms[i].PicImg = src.trim();
            }
            break;
          }
        }
      }
      textBooms = Util.emojiName(textBooms);
      // console.log(textBooms);
      return textBooms;
    },
  },
};
</script>

<style lang="less" scoped>
.wrapper-comment {
  padding: 1px 20px 20px 20px;
  background: #f5f5f5;
  position: relative;
    border-radius: 8px;
  margin-top: 26px;
  &::before {
    content: '';
    position: absolute;
    left: 20px;
    top: -12px;
    width: 0;
    height: 0;
    border-bottom: solid 12px #f5f5f5;
    border-left: solid 10px transparent;
    border-right: solid 10px transparent;
  }
  .addition {
    font-size: 28px;
    line-height: 38px;
    margin-bottom: 23px;
    color: #4c618f;
    display: flex;
    align-items: center;
    .img-more {
      width:32px;
      height:32px;
      margin-left: 10px;
    }
  }
  .block-like {
    display: flex;
    padding-top: 18px;
    .media {
      width: 30px;
      height: 30px;
      margin-right: 10px;
      vertical-align: middle;
    }
    .popular {
      font-size: 26px;
      line-height: 28px;
      color: #999999;
      vertical-align: middle;
    }
  }
}
.item-list {
  margin-top: 20px;
  .list-item {
    font-size: 28px;
    line-height: 38px;
  }
}

</style>
